import React from 'react'
import { CarCalculatorImage, Motorcycle, Timeline } from '../SVGIcons'

export const calculatorData = {
  monthly: {
    reportType: 'normal',
    description: false,
    sliders: [
      {
        sliderId: 'car-price',
        min: 5000,
        max: 2000000,
        defaultValue: 100000,
        step: 1000,
      },
      {
        sliderId: 'downpayment',
        min: 0,
        max: 1000000,
        defaultValue: 10000,
      },
      {
        sliderId: 'tenor-period',
        min: 6,
        max: 60,
        defaultValue: 60,
      },
      {
        sliderId: 'balloon-payment',
        min: 0,
        max: 1000000,
        defaultValue: 10000,
      },
    ],
  },
  '50-50': {
    image: '/assets/SVG Assets/SVG - Plain/03 Two-Payments Calculator.svg',
    description: true,
    reportType: 'normal',
    sliders: [
      {
        sliderId: 'car-price',
        min: 5000,
        max: 2000000,
        defaultValue: 100000,
        step: 1000,
      },
    ],
  },
  'sign-and-drive': {
    image: <CarCalculatorImage />,
    description: true,
    reportType: 'normal',
    sliders: [
      {
        label: 'Car Price',
        sliderId: 'car-price',
        unit: 'SAR',
        min: 5000,
        max: 2000000,
        defaultValue: 180000,
        step: 1000,
      },
    ],
  },
  flexi: {
    image: '/assets/SVG Assets/SVG - Plain/03-01 Yearly Calculator.svg',
    description: true,
    reportType: 'timeline',
    sliders: [
      {
        sliderId: 'car-price',
        min: 5000,
        max: 2000000,
        defaultValue: 190000,
        step: 1000,
      },
      {
        sliderId: 'tenor-period',
        min: 2,
        max: 5,
        defaultValue: 3,
      },
    ],
  },
  'sale-and-leaseback': {
    image: <Timeline />,
    description: true,
    reportType: 'normal',
    sliders: [
      {
        label: 'Car Price',
        sliderId: 'car-price',
        unit: 'SAR',
        min: 5000,
        max: 2000000,
        defaultValue: 200000,
        step: 1000,
      },
      {
        label: 'Tenor Period',
        sliderId: 'tenor-period',
        unit: 'Months',
        min: 6,
        max: 60,
        defaultValue: 60,
      },
      {
        label: 'Balloon Payment',
        sliderId: 'balloon-payment',
        unit: 'SAR',
        min: 0,
        max: 2000000,
        defaultValue: 0,
      },
    ],
  },
  motorcycle: {
    image: <Motorcycle />,
    description: true,
    reportType: 'normal',
    sliders: [
      {
        sliderId: 'motorcycle-price',
        min: 5000,
        max: 2000000,
        defaultValue: 200000,
        step: 1000,
      },
      {
        sliderId: 'tenor-period',
        min: 6,
        max: 60,
        defaultValue: 60,
      },
    ],
  },
  takhayer: {
    image: <Timeline />,
    description: true,
    reportType: 'normal',
    sliders: [
      {
        label: 'Car Price',
        sliderId: 'car-price',
        unit: 'SAR',
        min: 5000,
        max: 2000000,
        defaultValue: 100000,
        step: 1000,
      },
      {
        label: 'Takhayer',
        sliderId: 'takhayer-rate',
        unit: '%',
        min: 30,
        max: 40,
        defaultValue: 30,
        step: 10,
      },
    ],
  },
  'personal-finance-standard': {
    description: true,
    reportType: 'normal',
    sliders: [
      {
        label: 'Finance Amount',
        sliderId: 'finance-amount',
        unit: 'SAR',
        min: 51000,
        max: 1000000,
        defaultValue: 80000,
        step: 1000,
      },
      {
        label: 'Tenor Period',
        sliderId: 'tenor-period',
        unit: 'Months',
        min: 12,
        max: 60,
        defaultValue: 60,
        step: 6,
      },
    ],
  },
  'personal-finance-instant': {
    description: true,
    reportType: 'normal',
    sliders: [
      {
        label: 'Finance Amount',
        sliderId: 'finance-amount',
        unit: 'SAR',
        min: 3000,
        max: 50000,
        defaultValue: 3000,
        step: 100,
      },
      {
        label: 'Tenor Period',
        sliderId: 'tenor-period',
        unit: 'Months',
        min: 12,
        max: 36,
        defaultValue: 12,
        step: 12,
      },
    ],
  },
  'self-employed': {
    reportType: 'normal',
    description: false,
    sliders: [
      {
        sliderId: 'car-price',
        min: 5000,
        max: 2000000,
        defaultValue: 100000,
        step: 1000,
      },
      {
        sliderId: 'downpayment',
        min: 0,
        max: 1000000,
        defaultValue: 10000,
      },
      {
        sliderId: 'tenor-period',
        min: 6,
        max: 60,
        defaultValue: 60,
      },
      {
        sliderId: 'balloon-payment',
        min: 0,
        max: 1000000,
        defaultValue: 10000,
      },
    ],
  },
}
